module.exports = __webpack_public_path__ + "img/add-supplier-icon.fec6d872.svg";